import React from "react"
import types from "prop-types"
import ExpandMenu, { ExpandMenuItem } from "shared/ExpandMenu"
import * as API from "services/api"
import { useDispatch } from "react-redux"
import { removeWorkflow } from "reduxSlices/formBuilderSlice"
import ExpandMenuEllipsisButton from "shared/buttons/ExpandMenuEllipsisButton"

const WorkflowMenu = ({ formSlug, workflowId, openForm }) => {
  const dispatch = useDispatch()

  const deleteWorkflow = async () => {
    if (window.confirm("Are you sure you want to delete this workflow?")) {
      const response = await API.deleteWorkflow({ formSlug, workflowId })

      if (response.ok) {
        dispatch(removeWorkflow(workflowId))
      } else {
        console.error("Error deleting workflow: ", response)
      }
    }
  }

  return (
    <ExpandMenu expandMenuComponent={<ExpandMenuEllipsisButton />}>
      <ExpandMenuItem onClick={openForm}>
        <span>Edit</span>
      </ExpandMenuItem>
      <ExpandMenuItem onClick={deleteWorkflow}>
        <span>Delete</span>
      </ExpandMenuItem>
    </ExpandMenu>
  )
}

WorkflowMenu.propTypes = {
  formSlug: types.string.isRequired,
  workflowId: types.number.isRequired,
  openForm: types.func.isRequired,
}

export default WorkflowMenu
